/************ CONSTANTS ***********/
export const CURRENCY = "₪";
export const VP = "נק'";
export const FOOTER_HEIGHT = 30;
